import { DataLayer, getStoreAddress } from "@grandvisionhq/analytics";
const flowNameStock = "store stock availability";
const flowNameReservation = "find and reserve in store";
const events = {
  checkStoreAvailabilityClickEvent: {
    stock_only: {
      event: "click_and_reserve_check_store_availability_click",
      site_feature: "click and reserve",
      flow_name: flowNameStock
    },
    reservation: {
      event: "find_and_reserve_click",
      site_feature: "find and reserve",
      flow_name: flowNameReservation
    }
  },
  viewFindInStoreEvent: {
    stock_only: {
      event: "store_finder_start",
      site_feature: "store finder",
      flow_name: flowNameStock
    },
    reservation: {
      event: "choose_store_start",
      site_feature: "choose store",
      flow_name: flowNameReservation
    }
  },
  storeClickEvent: {
    stock_only: {
      event: "store_finder_store_click",
      site_feature: "store finder",
      flow_name: flowNameStock
    },
    reservation: {
      event: "choose_store_store_click",
      site_feature: "choose store",
      flow_name: flowNameReservation
    }
  },
  useMyCurrentLocationEvent: {
    stock_only: {
      event: "store_finder_use_my_location_click",
      site_feature: "store finder",
      flow_name: flowNameStock
    },
    reservation: {
      event: "choose_store_use_my_location_click",
      site_feature: "choose store",
      flow_name: flowNameReservation
    }
  },
  viewCustomerDetailsEvent: {
    reservation: {
      event: "your_details_start",
      site_feature: "your details",
      flow_name: flowNameReservation
    }
  },
  configuratorClickCloseEvent: {
    reservation: {
      event: "your_details_close_click",
      site_feature: "your details",
      flow_name: flowNameReservation
    }
  },
  configuratorClickBackEvent: {
    reservation: {
      event: "your_details_back_button_click",
      site_feature: "your details",
      flow_name: flowNameReservation
    }
  },
  requestReservationClickEvent: {
    reservation: {
      event: "your_details_request_reservation_click",
      site_feature: "your details",
      flow_name: flowNameReservation
    }
  },
  changeStoreClickEvent: {
    reservation: {
      event: "your_details_change_store_click",
      site_feature: "your details",
      flow_name: flowNameReservation
    }
  },
  viewRequestConfirmationEvent: {
    reservation: {
      event: "request_confirmation_start",
      site_feature: "request confirmation",
      flow_name: flowNameReservation
    }
  },
  preferredStoreClickEvent: {
    stock_only: {
      event: "preferred_store_click",
      site_feature: "store finder",
      flow_name: flowNameStock
    },
    reservation: {
      event: "preferred_store_click",
      site_feature: "choose store",
      flow_name: flowNameReservation
    }
  }
};
const pushEvent = (event) => DataLayer.pushEvent(event);
const pushCheckStoreAvailabilityClickEvent = (mode) => pushEvent(events.checkStoreAvailabilityClickEvent[mode]);
const pushViewFindInStoreEvent = (mode) => pushEvent(events.viewFindInStoreEvent[mode]);
const pushStoreClickEvent = (mode, store, search) => pushEvent({ ...events.storeClickEvent[mode], store, search });
const pushUseMyCurrentLocationEvent = (mode, clickLocation) => pushEvent({
  ...events.useMyCurrentLocationEvent[mode],
  click: {
    location: clickLocation
  }
});
const pushViewCustomerDetailsEvent = () => pushEvent(events.viewCustomerDetailsEvent.reservation);
const pushConfiguratorClickCloseEvent = (stepId) => {
  pushEvent({
    ...events.configuratorClickCloseEvent.reservation,
    step: {
      name: stepId === 1 ? "Your details" : "Request confirmation",
      id: stepId
    }
  });
};
const pushConfiguratorClickBackEvent = (stepId) => {
  pushEvent({
    ...events.configuratorClickBackEvent.reservation,
    step: {
      name: stepId === 1 ? "Your details" : "Request confirmation",
      id: stepId
    }
  });
};
const pushRequestReservationClickEvent = () => pushEvent(events.requestReservationClickEvent.reservation);
const pushChangeStoreClickEvent = () => pushEvent(events.changeStoreClickEvent.reservation);
const pushViewRequestConfirmationEvent = () => pushEvent(events.viewRequestConfirmationEvent.reservation);
const pushPreferredStoreClickEvent = (mode, variant, store) => pushEvent({
  ...events.preferredStoreClickEvent[mode],
  event: variant === "list-item" ? "preferred_store_click" : "preferred_store_map_click",
  store: {
    id: store.id.toLowerCase(),
    city: store.city.toLowerCase(),
    country: store.country,
    name: store.name.toLowerCase(),
    address: getStoreAddress({
      city: store.city,
      streetName: store.streetName,
      streetNumber: store.streetNumber,
      additionalStreetInfo: store.additionalStreetInfo
    }).toLowerCase(),
    postalCode: store.postalCode ?? "",
    stock: store.stockQuantity?.toString() ?? ""
  }
});
export {
  pushChangeStoreClickEvent,
  pushCheckStoreAvailabilityClickEvent,
  pushConfiguratorClickBackEvent,
  pushConfiguratorClickCloseEvent,
  pushPreferredStoreClickEvent,
  pushRequestReservationClickEvent,
  pushStoreClickEvent,
  pushUseMyCurrentLocationEvent,
  pushViewCustomerDetailsEvent,
  pushViewFindInStoreEvent,
  pushViewRequestConfirmationEvent
};
//# sourceMappingURL=ClickAndReserveEvents.js.map
